import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs/operators';

import {
  ReportBrokenLinkActionTypes,
  ReportBrokenLinkCancelAction,
  ReportBrokenLinkSuccessAction,
} from '®shared/list-item/report-broken-link-modal/report-broken-link.actions';

import { EventsService } from './events.service';
import {
  createReportBrokenLinkCancelEvent,
  createReportBrokenLinkSuccessEvent,
} from './report-broken-link-events';

@Injectable()
export class ReportBrokenLinkEventsEffects {
  constructor(
    private actions$: Actions,
    private eventsService: EventsService,
  ) {}

  recordReportBrokenLinkSuccessEvent$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ReportBrokenLinkActionTypes.REPORT_BROKEN_LINK_SUCCESS),
        tap((action: ReportBrokenLinkSuccessAction) => {
          this.eventsService.recordEvent(
            createReportBrokenLinkSuccessEvent(action.payload.brokenLinkReport),
          );
        }),
      ),
    { dispatch: false },
  );

  recordReportBrokenLinkCancelEvent$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ReportBrokenLinkActionTypes.REPORT_BROKEN_LINK_CANCEL),
        tap((action: ReportBrokenLinkCancelAction) => {
          this.eventsService.recordEvent(
            createReportBrokenLinkCancelEvent(
              action.payload.itemId,
              action.payload.screenResolution,
              action.payload.userAgent,
            ),
          );
        }),
      ),
    { dispatch: false },
  );
}
